module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "c-box"
  }, [_c('header', {
    staticClass: "c-box__heading",
    on: {
      "click": _vm.toggleVariationInfo
    }
  }, [_c('span', {
    staticClass: "check-box",
    class: _vm.selectClass,
    on: {
      "click": _vm.select
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('i', {
    staticClass: "u-floatRight",
    class: _vm.toggleIconClass()
  }), _vm._v(" "), (_vm.getErrorsBySku(_vm.variation.sku)) ? _c('span', {
    staticClass: "badge u-floatRight to-fix"
  }, [_vm._v(_vm._s(_vm.$t('to-fix').label))]) : _vm._e()]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    staticClass: "c-box__body"
  }, [_c('div', {
    staticClass: "c-box__inner"
  }, [_c('panel', {
    attrs: {
      "title": "Informações da variação"
    }
  }, [_c('div', {
    attrs: {
      "slot": "header-right"
    },
    slot: "header-right"
  }, [_c('button', {
    staticClass: "btn btn--sm btn--info btn-history",
    on: {
      "click": function($event) {
        return _vm.showPriceHistory(_vm.variation.sku)
      }
    }
  }, [_c('i', {
    staticClass: "icon-folder-search"
  }), _vm._v(" "), _c('span', [_vm._v("Histórico de alteração de preços")])])]), _vm._v(" "), _c('variation-attributes', {
    attrs: {
      "variation": _vm.variation,
      "fromModule": _vm.fromModule,
      "productId": _vm.productId
    }
  })], 1), _vm._v(" "), (_vm.category.variations_attributes) ? _c('panel', {
    attrs: {
      "title": "Atributos"
    }
  }, [_c('attributes', {
    attrs: {
      "product": _vm.variation,
      "attributes": _vm.category.variations_attributes,
      "sourceVariation": _vm.sourceVariation
    }
  })], 1) : _vm._e()], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_vm._v(_vm._s(_vm.variationTitle()))])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-087f1040","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/marketplace/mercadoLivre/announcement/edit/variation/Multi.vue
// module id = 2885
// module chunks = 0